import { ConfiguredColumn, ObjectFieldDTO } from '@types'

export const getPkField = (fields: ObjectFieldDTO[] | undefined | ConfiguredColumn[]) => {
  if (fields) {
    return fields?.find(field => field.isPk)
  }
}
